<template>
  <v-btn
    small
    depressed
    color="#b8e994"
    @click="openRenewMembershipDialog"
    v-if="anyActiveFieldActivities && !member.npsp__Deceased__c"
  >
    <v-icon small left> mdi-account-check </v-icon>
    <span v-if="membershipType == 'family'">
      Aktiviraj obiteljsko članstvo
    </span>
    <span v-else>Aktiviraj članstvo</span>
  </v-btn>
</template>

<script>
export default {
  props: ["member", "membershipType"],

  computed: {
    anyActiveFieldActivities() {
      return this.$store.state.anyActiveFieldActivities;
    },
  },

  methods: {
    openRenewMembershipDialog() {
      this.$store.dispatch("openRenewMembershipDialog", {
        users: [this.member],
        type: this.membershipType,
      });
    },
  },
};
</script>
